import { Component, OnInit, Inject, AfterViewChecked } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DndDropEvent } from 'ngx-drag-drop';
import { TranslateService } from '@ngx-translate/core';
import { CertificatesPrivateService, FeedMessageService, showSuccess, UtilsService } from '@services/index.service';
import { environment } from '@environments/environment';
import { DialogConfirmCancelComponent } from '@shared/index.shared';
import { CertificateEditRequest, ErrorCode, MessageType, Response } from '@models/index.model';
import { finalize, tap } from 'rxjs/operators';

@Component({
    selector: 'app-dialog-private-cert-upload',
    templateUrl: './dialog-private-cert-upload.component.html',
    styles: [],
    standalone: false
})
export class DialogPrivateCertUploadComponent implements OnInit, AfterViewChecked {
  public isMobile: boolean;
  tooltipTitle: any;
  fileSizeError64KB: any;
  hide: boolean = true;
  hide2: boolean = true;
  acDelay = environment.autoCompleteDelay;
  uploadIsFocus: boolean = false;
  sendingInfo = false;

  dropDownText: string;
  dropDownSelectAllText: string;
  dropDownUnSelectAllText: string;
  dropDownnoDataLabel: string;
  dropDownsearchPlaceholderText: string;

  loading: boolean = false;
  file1Droped: boolean = false;
  fileUpload: File = null;
  public lastDrop1Event: DndDropEvent | null = null;
  public lastDrop1Types: any;
  public lastDrop1Files: object[];
  public lastDrop1Items: object[];

  _certificate: any;
  certificateEditRequest: CertificateEditRequest;
  action: any;

  constructor(
    public translate: TranslateService,
    public dialog: MatDialog,
    private _notify: FeedMessageService,
    private _privCertsServ: CertificatesPrivateService,
    public _utils: UtilsService,
    public dialogRef: MatDialogRef<DialogPrivateCertUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isMobile = environment.platform === 'mobile';
    translate.get(['GLOBAL.TOOLTIP']).subscribe((res) => {
      this.tooltipTitle = res['GLOBAL.TOOLTIP'];
    });
    translate.get(['GLOBAL.ERRORS']).subscribe((res) => {
      this.fileSizeError64KB = res['GLOBAL.ERRORS']['FILESIZE64KB'];
    });
  }

  ngOnInit() {
    this.data.fileUpload = null;
    this.data.toPin = null;
  }

  ngAfterViewChecked() { }

  onFile1Drop( event: DndDropEvent ) {
    event.event.preventDefault();
    this.lastDrop1Event = event;
    this.file1Droped = true;
    this.lastDrop1Types = this.lastDrop1Event.event.dataTransfer.types;
    this.lastDrop1Files = [];
    this.data.fileUpload = this.lastDrop1Event.event.dataTransfer.files[0];
    for ( let i: number = 0; i < this.lastDrop1Event.event.dataTransfer.files.length; i++ ) {
      const file = this.lastDrop1Event.event.dataTransfer.files[ i ];
      this.lastDrop1Files.push( {
        lastModifiedDate: file.lastModified,
        name: file.name,
        type: file.type,
        size: file.size,
      } );
    }
    this.lastDrop1Items = [];
    for ( let i: number = 0; i < this.lastDrop1Event.event.dataTransfer.items.length; i++ ) {
      const item = this.lastDrop1Event.event.dataTransfer.items[i];
      this.lastDrop1Items.push( {
        type: item.type,
        kind: item.kind,
        data: this.lastDrop1Event.event.dataTransfer.getData( item.type )
      } );
    }
  }

  certificate() {
    this.sendingInfo = true;
    this._privCertsServ.uploadPersonalCertificate(this.certificateEditRequest, this.fileUpload)
    .pipe(
      tap((res: Response<any>) => {
        this._notify.feedBackResult(res.messageType, res.message, showSuccess);
        if (res.errorCode === ErrorCode.OK) {
          this.dialogRef.close(true);
        }
      }),
      finalize(() => {
        this.sendingInfo = false;
      })
    ).subscribe();
  }

  sendData(result) {
    if (result && result.toPassword && result.fileUpload) {
      this.certificateEditRequest = {
        password: result.toPassword,
        pin: result.toPin
      };
      this.fileUpload = result.fileUpload;
      this.certificate();
    }
  }

  fileSizeValidate(elementFake, element, event) {
    if ((event.target.files) && (event.target.files[0].size > 65536)) {
      this._notify.feedBackResult(MessageType.ERROR, this.fileSizeError64KB);
      elementFake.value = '';
      element.value = '';
      this.data.fileUpload =  '';
    }
  }

  cancelChanges() {
    const dialogRef = this.dialog.open(DialogConfirmCancelComponent, {
      width: '400px',
      data: {}
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.dialogRef.close(false);
      }
    });
  }
}

